import { useMemo } from "react"
import { useDrilldownSeed } from "connected-components/dashboard/drilldown/drilldown-seed-context"
import {
  assetViewSlice,
  ASSET_VIEW_PREFERENCE_BASE,
  selectAssetViewPanel,
} from "connected-components/dashboard/store/asset-view-slice"
import {
  createTemplateChartHook,
  type TemplateChartResult,
} from "connected-components/dashboard/hooks/create-template-chart-hook"
import type { AssetViewChartConfig } from "../templates/template-chart-config"

const useAssetViewTemplateChartBase = createTemplateChartHook({
  preferenceBase: ASSET_VIEW_PREFERENCE_BASE,
  selectPanel: selectAssetViewPanel,
  setTemplateChartSetting: assetViewSlice.actions.setTemplateChartSetting,
  seedTemplateChart: assetViewSlice.actions.seedTemplateChart,
})

// Per-template chart settings for the asset-view panel slice (risk, performance, exposure, beta,
// content-set, factor-sensitivity). When the panel carries a drilldownSeed (a pinned drilldown),
// the template's resolveSeed sets the initial settings once (existence-guarded).
export function useAssetViewTemplateChart(
  { templateKey, defaults, resolveSeed }: AssetViewChartConfig,
): TemplateChartResult {
  const drilldownSeed = useDrilldownSeed()
  const seed = useMemo(
    () => (resolveSeed ? resolveSeed(drilldownSeed) : null),
    [resolveSeed, drilldownSeed],
  )
  return useAssetViewTemplateChartBase(templateKey, defaults, seed)
}
